<script setup>
import {ref, onMounted, watch} from "vue";
import {definePage} from "unplugin-vue-router/runtime";
import {useAdminStore} from "@/stores/admin.js";
import {storeToRefs} from 'pinia';
import {useRouter} from "vue-router";
import createApiService from "@/services/api.js";
import {useMessageStore} from "@/stores/message.js";

definePage({
  meta: {
    title: 'Home',
    requiresAuth: true,
    admin: true,
    layout: 'admin',
  },
})

const adminStore = useAdminStore();

const {client} = storeToRefs(adminStore);
watch(client, async () => {
  await getUserTasks();
});

const router = useRouter();
const api = createApiService(router);
const messageStore = useMessageStore();
const loading = ref(true);
const errors = ref([]);

const allTasks = ref([]);

const getUserTasks = async () => {

  try {
    const response = await api.post('getadminusertasks', {userId: client.value});

    if (response.status === 200) {
      allTasks.value = response.data.data.tasks;
    }
    else {
      errors.value = ['Er is iets misgegaan. Probeer het later nog eens.'];
    }
  } catch (e) {
    errors.value = e.response?.status === 400 ? [e.response.data.message] : ['Er is iets misgegaan. Probeer het later nog eens.'];
  } finally {
    loading.value = false;
  }
}

const removeTask = async (taskId) => {
  loading.value = true;

  try {
    const response = await api.post('deleteadmintask', {id: taskId})
    if (response.status === 200) {
      await getUserTasks();
      message.value = {
        message: response.data.message,
        type: 'success',
      }
    }
    else {
      errors.value = ['Er is iets misgegaan. Probeer het later nog eens.'];
    }
  } catch (e) {
    errors.value = e.response?.status === 400 ? [e.response.data.message] : ['Er is iets misgegaan. Probeer het later nog eens.'];
  } finally {
    loading.value = false;
  }
}

const message = ref(null);

onMounted(async () => {
  await getUserTasks();
  if (messageStore.message !== '') {
    message.value = {
      message: messageStore.message,
      type: messageStore.type,
    }
    messageStore.removeMessage();
  }
})
</script>

<template>
  <v-alert
    v-if="message"
    class="mx-auto mb-5"
    max-width="500"
    :color="message.type"
    variant="elevated"
  >
    {{ message.message }}
  </v-alert>

  <h3 v-if="!client" class="text-center">Geen client geselecteerd</h3>
  <h3 v-else-if="allTasks?.length === 0" class="text-center">Geen taken gevonden</h3>
  <v-sheet v-else class="bg-primary text-center px-6 mb-4 mx-auto" max-width="500">
    <edit-task
      v-for="(userTask, index) in allTasks"
      :key="userTask.id" :task="userTask"
      :is-last="index === allTasks.length - 1"
      @delete="removeTask(userTask.id)"
      @click="router.push(`/admin/taken/${userTask.id}`)"
    ></edit-task>
  </v-sheet>
</template>

<style scoped>

</style>
